(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["patimoro-autotoy"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const timer=root.querySelector('[data-countdown]');if(timer){const end=Date.parse(timer.dataset.end);let clock;function tick(){const seconds=Math.max(0,Math.ceil((end-Date.now())/1000));if(!Number.isFinite(end)||seconds<=0){timer.hidden=true;root.querySelectorAll('[data-campaign-shipping]').forEach(el=>el.hidden=true);if(clock)clearInterval(clock);return false}const values={days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};Object.entries(values).forEach(([unit,value])=>{const el=timer.querySelector('[data-unit='+unit+']');const text=String(value).padStart(2,'0');if(el.textContent!==text){el.textContent=text;el.classList.remove('pa-tick');void el.offsetWidth;el.classList.add('pa-tick')}});return true}if(tick())clock=setInterval(()=>{if(!root.isConnected){clearInterval(clock);return}tick()},1000)}root.querySelectorAll('[data-thumb]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-slide]').forEach(slide=>slide.hidden=slide.dataset.slide!==button.dataset.thumb);root.querySelectorAll('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));const select=root.querySelector('[data-variant]'),buy=root.querySelector('[data-buy]'),price=root.querySelector('[data-price]');if(!select||!buy)return;function refresh(){const option=select.selectedOptions[0],cents=Number(option.dataset.price),qty=Number(root.querySelector('[name=quantity]:checked').value);price.textContent=cents>0?new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(cents*qty/100):buy.dataset.soon;const compare=Number(option.dataset.compare),oldPrice=root.querySelector('[data-compare]'),saleLabel=root.querySelector('[data-sale-label]');oldPrice.hidden=!(compare>cents&&cents>0);saleLabel.hidden=oldPrice.hidden;if(!oldPrice.hidden)oldPrice.textContent=new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(compare*qty/100);buy.disabled=cents<=0||option.dataset.available!=='true';buy.textContent=cents<=0?buy.dataset.soon:option.dataset.available==='true'?buy.dataset.add:buy.dataset.sold}select.addEventListener('change',()=>{refresh();if(select.options.length<2)return;const thumbs=root.querySelectorAll('[data-thumb]');const index=select.selectedIndex===0?thumbs.length-2:thumbs.length-1;thumbs[index]?.click()});root.querySelectorAll('[name=quantity]').forEach(i=>i.addEventListener('change',refresh));root.querySelector('form').addEventListener('submit',e=>{if(buy.disabled)e.preventDefault()});refresh()}document.querySelectorAll('[data-pa]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pa]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patimoro-ball"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ballReady) return;
    root.dataset.ballReady = 'true';
    root.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== button.dataset.thumb; });
      root.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    const form = root.querySelector('form');
    const select = root.querySelector('[data-variant]');
    const buy = root.querySelector('[data-buy]');
    const mobileBuy = root.querySelector('[data-mobile-buy]');
    const error = root.querySelector('[data-error-message]');
    if (!form || !select || !buy) return;
    const offer = root.querySelector('[data-ball-offer]');
    const rows = Array.from(root.querySelectorAll('[data-offer-item]'));
    if (offer) offer.hidden = !rows.length;
    const money = cents => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: root.dataset.currency || 'TRY' }).format(cents / 100);
    const qty = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    const selected = () => rows.filter(row => row.querySelector('[data-offer-check]').checked);
    const extraVariant = row => row.querySelector('[data-offer-variant]');
    const extraPrice = row => Number(extraVariant(row).selectedOptions[0].dataset.price);
    const discounted = row => Math.round(extraPrice(row) * 0.85);
    const routeRoot = root.dataset.root.replace(/\/?$/, '/');
    const codes = { glove: 'PATIMORO-HAREKETLI-ELDIVEN15', launcher: 'PATIMORO-HAREKETLI-FIRLATICI15', both: 'PATIMORO-HAREKETLI-IKILI15' };
    let busy = false;
    function refresh() {
      const option = select.selectedOptions[0];
      const cents = Number(option.dataset.price);
      const extras = selected();
      const total = cents * qty() + extras.reduce((sum, row) => sum + discounted(row), 0);
      const totalText = money(total);
      root.querySelector('[data-price]').textContent = totalText;
      root.querySelector('[data-mobile-price]').textContent = totalText;
      root.querySelectorAll('[data-pack-price]').forEach(el => { el.textContent = money(cents * Number(el.dataset.packPrice)); });
      const old = root.querySelector('[data-compare]');
      const compare = Number(option.dataset.compare);
      old.hidden = !(compare > cents && !extras.length);
      root.querySelector('[data-sale-label]').hidden = old.hidden;
      if (!old.hidden) old.textContent = money(compare * qty());
      rows.forEach(row => {
        row.querySelector('[data-offer-old]').textContent = money(extraPrice(row));
        row.querySelector('[data-offer-price]').textContent = money(discounted(row));
      });
      if (offer) {
        offer.querySelector('[data-offer-total]').hidden = !extras.length;
        offer.querySelector('[data-offer-sum]').textContent = totalText;
        offer.querySelector('[data-offer-saving]').textContent = money(extras.reduce((sum, row) => sum + extraPrice(row) - discounted(row), 0));
      }
      buy.disabled = busy || cents <= 0 || option.dataset.available !== 'true';
      buy.textContent = busy ? root.dataset.busy : cents <= 0 ? buy.dataset.soon : option.dataset.available === 'true' ? buy.dataset.add : buy.dataset.sold;
      mobileBuy.disabled = buy.disabled;
      mobileBuy.textContent = buy.textContent;
    }
    form.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || buy.disabled) return;
      const extras = selected();
      const items = [{ id: Number(select.value), quantity: qty() }, ...extras.map(row => ({ id: Number(extraVariant(row).value), quantity: 1 }))];
      busy = true;
      error.hidden = true;
      refresh();
      form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        if (extras.length) {
          const code = codes[extras.length === 2 ? 'both' : extras[0].dataset.key];
          window.location.assign(routeRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root.dataset.cart));
        } else {
          window.location.assign(root.dataset.cart);
        }
      } catch (err) {
        error.textContent = err.message || root.dataset.error;
        error.hidden = false;
        busy = false;
        form.removeAttribute('aria-busy');
        refresh();
      }
    });
    refresh();
  }
  document.querySelectorAll('[data-pb]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pb]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patimoro-duck"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-related-price]').forEach(el=>el.textContent=new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(Number(el.dataset.relatedPrice)/100));const timer=root.querySelector('[data-countdown]');if(timer){const end=Date.parse(timer.dataset.end);let clock;function tick(){const seconds=Math.max(0,Math.ceil((end-Date.now())/1000));if(!Number.isFinite(end)||seconds<=0){timer.hidden=true;root.querySelectorAll('[data-campaign-shipping]').forEach(el=>el.hidden=true);if(clock)clearInterval(clock);return false}const values={days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};Object.entries(values).forEach(([unit,value])=>{const el=timer.querySelector('[data-unit='+unit+']');const text=String(value).padStart(2,'0');if(el.textContent!==text){el.textContent=text;el.classList.remove('pa-tick');void el.offsetWidth;el.classList.add('pa-tick')}});return true}if(tick())clock=setInterval(()=>{if(!root.isConnected){clearInterval(clock);return}tick()},1000)}root.querySelectorAll('[data-thumb]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-slide]').forEach(slide=>slide.hidden=slide.dataset.slide!==button.dataset.thumb);root.querySelectorAll('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));const select=root.querySelector('[data-variant]'),buy=root.querySelector('[data-buy]'),price=root.querySelector('[data-price]');if(!select||!buy)return;function refresh(){const option=select.selectedOptions[0],cents=Number(option.dataset.price),qty=Number(root.querySelector('[name=quantity]:checked').value);price.textContent=cents>0?new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(cents*qty/100):buy.dataset.soon;const compare=Number(option.dataset.compare),oldPrice=root.querySelector('[data-compare]'),saleLabel=root.querySelector('[data-sale-label]');oldPrice.hidden=!(compare>cents&&cents>0);saleLabel.hidden=oldPrice.hidden;if(!oldPrice.hidden)oldPrice.textContent=new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(compare*qty/100);buy.disabled=cents<=0||option.dataset.available!=='true';buy.textContent=cents<=0?buy.dataset.soon:option.dataset.available==='true'?buy.dataset.add:buy.dataset.sold}select.addEventListener('change',refresh);root.querySelectorAll('[name=quantity]').forEach(i=>i.addEventListener('change',refresh));root.querySelector('form').addEventListener('submit',e=>{if(buy.disabled)e.preventDefault()});refresh()}document.querySelectorAll('[data-pa]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pa]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patimoro-glove"] && !Shopify.designMode) return;
  try {
    

(() => {
 function init(root) {
  if (root.dataset.gloveReady) return;
  root.dataset.gloveReady = 'true';
  root.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
   root.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== button.dataset.thumb; });
   root.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
  const select = root.querySelector('[data-variant]'), buy = root.querySelector('[data-buy]');
  if (!select || !buy) return;
  const mobileBuy = root.querySelector('[data-mobile-buy]');
  const money = value => new Intl.NumberFormat('tr-TR', {style: 'currency', currency: root.dataset.currency || 'TRY'}).format(value / 100);
  function refresh() {
   const option = select.selectedOptions[0];
   const cents = Number(option.dataset.price);
   const qty = Number(root.querySelector('[name="quantity"]:checked')?.value || 1);
   const text = cents > 0 ? money(cents * qty) : buy.dataset.soon;
   root.querySelector('[data-price]').textContent = text;
   root.querySelector('[data-mobile-price]').textContent = text;
   root.querySelectorAll('[data-pack-price]').forEach(el => { el.textContent = cents > 0 ? money(cents * Number(el.dataset.packPrice)) : buy.dataset.soon; });
   const compare = Number(option.dataset.compare), old = root.querySelector('[data-compare]');
   old.hidden = !(compare > cents && cents > 0);
   root.querySelector('[data-sale-label]').hidden = old.hidden;
   if (!old.hidden) old.textContent = money(compare * qty);
   buy.disabled = cents <= 0 || option.dataset.available !== 'true';
   buy.textContent = cents <= 0 ? buy.dataset.soon : option.dataset.available === 'true' ? buy.dataset.add : buy.dataset.sold;
   mobileBuy.disabled = buy.disabled;
   mobileBuy.textContent = buy.textContent;
  }
  select.addEventListener('change', refresh);
  root.querySelectorAll('[name="quantity"]').forEach(input => input.addEventListener('change', refresh));
  root.querySelector('form').addEventListener('submit', event => { if (buy.disabled) event.preventDefault(); });
  refresh();
 }
 document.querySelectorAll('[data-pg]').forEach(init);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pg]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patimoro-launcher"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const timer=root.querySelector('[data-countdown]');if(timer){const end=Date.parse(timer.dataset.end);let clock;function tick(){const seconds=Math.max(0,Math.ceil((end-Date.now())/1000));if(!Number.isFinite(end)||seconds<=0){timer.hidden=true;root.querySelectorAll('[data-campaign-shipping]').forEach(el=>el.hidden=true);if(clock)clearInterval(clock);return false}const values={days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};Object.entries(values).forEach(([unit,value])=>{const el=timer.querySelector('[data-unit='+unit+']');const text=String(value).padStart(2,'0');if(el.textContent!==text){el.textContent=text;el.classList.remove('pa-tick');void el.offsetWidth;el.classList.add('pa-tick')}});return true}if(tick())clock=setInterval(()=>{if(!root.isConnected){clearInterval(clock);return}tick()},1000)}root.querySelectorAll('[data-thumb]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-slide]').forEach(slide=>slide.hidden=slide.dataset.slide!==button.dataset.thumb);root.querySelectorAll('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));const select=root.querySelector('[data-variant]'),buy=root.querySelector('[data-buy]'),price=root.querySelector('[data-price]');if(!select||!buy)return;function refresh(){const option=select.selectedOptions[0],cents=Number(option.dataset.price),qty=Number(root.querySelector('[name=quantity]:checked').value);price.textContent=cents>0?new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(cents*qty/100):buy.dataset.soon;const compare=Number(option.dataset.compare),oldPrice=root.querySelector('[data-compare]'),saleLabel=root.querySelector('[data-sale-label]');oldPrice.hidden=!(compare>cents&&cents>0);saleLabel.hidden=oldPrice.hidden;if(!oldPrice.hidden)oldPrice.textContent=new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY'}).format(compare*qty/100);buy.disabled=cents<=0||option.dataset.available!=='true';buy.textContent=cents<=0?buy.dataset.soon:option.dataset.available==='true'?buy.dataset.add:buy.dataset.sold}select.addEventListener('change',refresh);root.querySelectorAll('[name=quantity]').forEach(i=>i.addEventListener('change',refresh));root.querySelector('form').addEventListener('submit',e=>{if(buy.disabled)e.preventDefault()});refresh()}document.querySelectorAll('[data-pa]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pa]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patimoro-saklambac"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.saklambacReady) return;
    root.dataset.saklambacReady = 'true';
    root.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== button.dataset.thumb; });
      root.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    const form = root.querySelector('form');
    const select = root.querySelector('[data-variant]');
    const buy = root.querySelector('[data-buy]');
    const mobileBuy = root.querySelector('[data-mobile-buy]');
    if (!form || !select || !buy || !mobileBuy) return;
    const error = root.querySelector('[data-error-message]');
    const offer = root.querySelector('[data-saklambac-offer]');
    const rows = Array.from(root.querySelectorAll('[data-offer-item]'));
    if (offer) offer.hidden = !rows.length;
    const qty = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    const selected = () => qty() === 1 ? rows.filter(row => row.querySelector('[data-offer-check]').checked) : [];
    const extraVariant = row => row.querySelector('[data-offer-variant]');
    const extraPrice = row => Number(extraVariant(row).selectedOptions[0].dataset.price);
    const discounted = row => Math.round(extraPrice(row) * 0.85);
    const routeRoot = root.dataset.root.replace(/\/?$/, '/');
    const codes = { glove: 'PATIMORO-SAKLAMBAC-ELDIVEN15', launcher: 'PATIMORO-SAKLAMBAC-FIRLATICI15', both: 'PATIMORO-SAKLAMBAC-IKILI15' };
    let busy = false;
    const money = cents => new Intl.NumberFormat('tr-TR', {style:'currency', currency:root.dataset.currency || 'TRY'}).format(cents / 100);
    function refresh() {
      const option = select.selectedOptions[0];
      const selectedPack = form.querySelector('[name="quantity"]:checked');
      const quantity = Number(selectedPack?.value || 1);
      const discount = Number(selectedPack?.dataset.discount || 0);
      const cents = Number(option.dataset.price);
      const compare = Number(option.dataset.compare);
      rows.forEach(row => {
        const check = row.querySelector('[data-offer-check]');
        check.disabled = quantity > 1 || busy;
        if (quantity > 1) check.checked = false;
        row.querySelector('[data-offer-old]').textContent = money(extraPrice(row));
        row.querySelector('[data-offer-price]').textContent = money(discounted(row));
      });
      const extras = selected();
      const total = Math.round(cents * quantity * (100 - discount) / 100) + extras.reduce((sum, row) => sum + discounted(row), 0);
      root.querySelector('[data-price]').textContent = money(total);
      root.querySelector('[data-mobile-price]').textContent = money(total);
      root.querySelectorAll('[data-pack-price]').forEach(el => { el.textContent = money(Math.round(cents * Number(el.dataset.packPrice) * (100 - Number(el.dataset.discount)) / 100)); });
      const old = root.querySelector('[data-compare]');
      old.hidden = extras.length > 0 || (discount === 0 && !(compare > cents));
      root.querySelector('[data-sale-label]').hidden = old.hidden;
      if (!old.hidden) old.textContent = money((discount > 0 ? cents : compare) * quantity);
      if (offer) {
        offer.dataset.disabled = String(quantity > 1);
        offer.querySelector('[data-offer-limit]').hidden = quantity === 1;
        offer.querySelector('[data-offer-total]').hidden = !extras.length;
        offer.querySelector('[data-offer-sum]').textContent = money(total);
        offer.querySelector('[data-offer-saving]').textContent = money(extras.reduce((sum, row) => sum + extraPrice(row) - discounted(row), 0));
      }
      buy.disabled = busy || cents <= 0 || option.dataset.available !== 'true';
      buy.textContent = busy ? root.dataset.busy : cents <= 0 ? buy.dataset.soon : option.dataset.available === 'true' ? buy.dataset.add : buy.dataset.sold;
      mobileBuy.disabled = buy.disabled;
      mobileBuy.textContent = buy.textContent;
    }
    form.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      if (busy) { event.preventDefault(); return; }
      const extras = selected();
      if (!extras.length) return;
      event.preventDefault();
      if (buy.disabled) return;
      const items = [{ id: Number(select.value), quantity: 1 }, ...extras.map(row => ({ id: Number(extraVariant(row).value), quantity: 1 }))];
      const code = codes[extras.length === 2 ? 'both' : extras[0].dataset.key];
      busy = true;
      error.hidden = true;
      refresh();
      form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        window.location.assign(routeRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root.dataset.cart));
      } catch (err) {
        error.textContent = err.message || root.dataset.error;
        error.hidden = false;
        busy = false;
        form.removeAttribute('aria-busy');
        refresh();
      }
    });
    refresh();
  }
  document.querySelectorAll('[data-ps]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ps]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patimoro-toy"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ballReady) return;
    root.dataset.ballReady = 'true';
    root.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== button.dataset.thumb; });
      root.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    const form = root.querySelector('form');
    const select = root.querySelector('[data-variant]');
    const buy = root.querySelector('[data-buy]');
    const mobileBuy = root.querySelector('[data-mobile-buy]');
    const error = root.querySelector('[data-error-message]');
    if (!form || !select || !buy) return;
    const offer = root.querySelector('[data-ball-offer]');
    const rows = Array.from(root.querySelectorAll('[data-offer-item]'));
    if (offer) offer.hidden = !rows.length;
    const money = cents => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: root.dataset.currency || 'TRY' }).format(cents / 100);
    const qty = () => Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    const selected = () => rows.filter(row => row.querySelector('[data-offer-check]').checked);
    const extraVariant = row => row.querySelector('[data-offer-variant]');
    const extraPrice = row => Number(extraVariant(row).selectedOptions[0].dataset.price);
    const discounted = row => Math.round(extraPrice(row) * 0.85);
    const routeRoot = root.dataset.root.replace(/\/?$/, '/');
    const codes = { glove: 'PATIMORO-HAREKETLI-ELDIVEN15', launcher: 'PATIMORO-HAREKETLI-FIRLATICI15', both: 'PATIMORO-HAREKETLI-IKILI15' };
    let busy = false;
    function refresh() {
      const option = select.selectedOptions[0];
      const cents = Number(option.dataset.price);
      const extras = selected();
      const total = cents * qty() + extras.reduce((sum, row) => sum + discounted(row), 0);
      const totalText = money(total);
      root.querySelector('[data-price]').textContent = totalText;
      root.querySelector('[data-mobile-price]').textContent = totalText;
      root.querySelectorAll('[data-pack-price]').forEach(el => { el.textContent = money(cents * Number(el.dataset.packPrice)); });
      const old = root.querySelector('[data-compare]');
      const compare = Number(option.dataset.compare);
      old.hidden = !(compare > cents && !extras.length);
      root.querySelector('[data-sale-label]').hidden = old.hidden;
      if (!old.hidden) old.textContent = money(compare * qty());
      rows.forEach(row => {
        row.querySelector('[data-offer-old]').textContent = money(extraPrice(row));
        row.querySelector('[data-offer-price]').textContent = money(discounted(row));
      });
      if (offer) {
        offer.querySelector('[data-offer-total]').hidden = !extras.length;
        offer.querySelector('[data-offer-sum]').textContent = totalText;
        offer.querySelector('[data-offer-saving]').textContent = money(extras.reduce((sum, row) => sum + extraPrice(row) - discounted(row), 0));
      }
      buy.disabled = busy || cents <= 0 || option.dataset.available !== 'true';
      buy.textContent = busy ? root.dataset.busy : cents <= 0 ? buy.dataset.soon : option.dataset.available === 'true' ? buy.dataset.add : buy.dataset.sold;
      mobileBuy.disabled = buy.disabled;
      mobileBuy.textContent = buy.textContent;
    }
    form.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || buy.disabled) return;
      const extras = selected();
      const items = [{ id: Number(select.value), quantity: qty() }, ...extras.map(row => ({ id: Number(extraVariant(row).value), quantity: 1 }))];
      busy = true;
      error.hidden = true;
      refresh();
      form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        if (extras.length) {
          const code = codes[extras.length === 2 ? 'both' : extras[0].dataset.key];
          window.location.assign(routeRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root.dataset.cart));
        } else {
          window.location.assign(root.dataset.cart);
        }
      } catch (err) {
        error.textContent = err.message || root.dataset.error;
        error.hidden = false;
        busy = false;
        form.removeAttribute('aria-busy');
        refresh();
      }
    });
    refresh();
  }
  document.querySelectorAll('[data-pb]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pb]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
